import {
  Alert,
  Button,
  Card,
  Divider,
  message,
  Row,
  Space,
  Tag,
  Typography,
} from 'antd';
import { CheckCircleTwoTone, CopyOutlined } from '@ant-design/icons';
import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { AppRouteKey } from '../../core/utilities/router';
import useRouterWithLang from '../../core/hooks/useRouterWithLang';
const { Text, Title } = Typography;
const RegisterActivationSuccess = () => {
  const [params] = useSearchParams();
  const userId = params.get('userId') || '';
  const fullName = params.get('userNameSurname') || '';
  const { provideUrl } = useRouterWithLang();
  const copy = async (val: string, label: string) => {
    try {
      await navigator.clipboard.writeText(val);
      message.success(`${label} kopyalandı`);
    } catch {
      message.error('Kopyalama başarısız');
    }
  };
  return (
    <Card
      style={{ maxWidth: 420, borderRadius: 16 }}
      bodyStyle={{ padding: 18 }}
    >
      <Space direction="vertical" size={8} style={{ width: '100%' }}>
        <Space align="center">
          <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: 22 }} />
          <Title level={4} style={{ margin: 0 }}>
            Kayıt başarıyla onaylandı
          </Title>
        </Space>

        <Text type="secondary">
          Aşağıdaki bilgilerle hesabınız aktif edildi.
        </Text>

        <Divider style={{ margin: '8px 0' }} />

        <Space direction="vertical" size={6} style={{ width: '100%' }}>
          <Space align="baseline" wrap>
            <Text strong>Ad Soyad:</Text>
            <Tag style={{ marginInlineStart: 6 }}>{fullName || '-'}</Tag>
            {fullName && (
              <Button
                size="small"
                type="text"
                icon={<CopyOutlined />}
                onClick={() => copy(fullName, 'Ad Soyad')}
              />
            )}
          </Space>

          <Space align="baseline" wrap>
            <Text strong>Kullanıcı ID:</Text>
            <Tag color="blue" style={{ marginInlineStart: 6 }}>
              {userId || '-'}
            </Tag>
            {'userId' && (
              <Button
                size="small"
                type="text"
                icon={<CopyOutlined />}
                onClick={() => copy(userId, 'Kullanıcı ID')}
              />
            )}
          </Space>
        </Space>

        <Alert
          type="success"
          showIcon
          message="Hesap başarılı bir şekilde etkinleştirildi."
          description={''}
          style={{ marginBlock: 16 }}
        />

        <Row className="justify-center">
          <Button type="primary">
            <Link to={provideUrl(AppRouteKey.HOME)}>Ana Sayfa</Link>
          </Button>
        </Row>
      </Space>
    </Card>
  );
};

export default RegisterActivationSuccess;
